<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>T&eacute;rminos y Condiciones</label>
    </h2>
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupbg">
                <div class="popupcont f-reg f-black roboto-r">
                    <div class="termr-t ">

                        <div class="basicrow">
                            <div>
                                <div>
                                    <div class="padTerms" style="line-height:2;">
                                        <div class="">
                                            <div class="">
                                                <div class="padtop">
                                                    • Al aceptar la compra del regalo, se le facturará a su cuenta el
                                                    total
                                                    de la recarga adquirida según se indica y podrá verlo en su
                                                    próxima factura.
                                                </div>
                                                <div class="padtop">
                                                    • El número de teléfono prepago de la persona que recibirá el
                                                    regalo deberá ser un número de telefonía móvil prepago activo de
                                                    Claro Puerto Rico exclusivamente.
                                                </div>
                                                <div class="padtop">
                                                    • El regalo no aplica a teléfonos fijos de Claro, teléfonos pospago
                                                    de
                                                    Claro o de otras compañías de teléfonos u otros países.
                                                </div>
                                                <div class="padtop">
                                                    • El cliente prepago recipiente del regalo verá reflejada la recarga
                                                    el
                                                    mismo día de la compra.
                                                </div>
                                                <div class="padtop">
                                                    • Aplican todos los Términos y Condiciones asociados a las recargas
                                                    del servicio prepago para clientes a granel y de renta mensual,
                                                    dependiendo el plan que tenga activo el cliente prepago al
                                                    momento de recibir el regalo de la recarga.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <div class="logline full top-r1"></div>
    <div class="basicrow text-center m-top">
        <a class="btns def-i red pull-right vcenter" (click)="this.close();">
            <span class="tabcell">
                Cerrar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>